import { render, staticRenderFns } from "./StakingCurrenciesExtra.vue?vue&type=template&id=f61c7450&scoped=true&"
import script from "./StakingCurrenciesExtra.vue?vue&type=script&lang=js&"
export * from "./StakingCurrenciesExtra.vue?vue&type=script&lang=js&"
import style0 from "./StakingCurrenciesExtra.vue?vue&type=style&index=0&id=f61c7450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c7450",
  null
  
)

export default component.exports